<div class="departments-wrapper">
  <div class="row shadow categories categories"  [ngClass]="{'bg-blue': !setColor}" [ngStyle]="{'background-color': colorDepartment}">
    <div class="col-9 cont-deparments" [ngClass]="{'col-12': !isOtherCategory()}">
      <div class="row cont-list-deparments">
        <div id="department-menu-toggle" *ngFor="let department of arrayDepartments" class="col-md-2 department">
          <a class="link" (click)="setChangeColor(department)" [id]="'department-menu-department-' + department?.id"
            routerLink="/categorias/{{ department?.nameUrl }}" [ngClass]="department?.classColor">
            <span class="text-title-deparment">{{ department?.name }}</span>
            <app-icons [type]="'arrow-fill'"></app-icons>
          </a>

          <div class="content-category" [ngStyle]="{'border-top-color': department?.primaryColor}">
            <div *ngIf="!activeDepartment[department?.name]" [class]="'sub-category ' + department?.link">
              <div class="category-container" *ngFor="let categoryItem of department?.children">
                <h3 class="titlte-category">
                  <a (click)="setChangeColor(department, categoryItem.name)" [ngStyle]="{color: department?.primaryColor}"
                    [id]="'department-menu-category-' + categoryItem.id"
                    routerLink="/categorias/{{ department?.nameUrl }}/{{ categoryItem.nameUrl }}">
                    {{ categoryItem.name }}
                  </a>
                </h3>
                <p class="cont-sub-category" *ngFor="let subCategory of categoryItem.children">
                  <a (click)="setChangeColor(department)" class="text-sub-category"
                    [id]="'department-menu-sub-category-' + subCategory.id" routerLink="/categorias/{{ department?.nameUrl }}/{{ categoryItem.nameUrl }}/{{
                      subCategory.nameUrl
                    }}">
                    {{ subCategory.name }}
                  </a>
                </p>
              </div>
            </div>
            <div *ngIf="activeDepartment[department?.name]" class="sub-category-img">
              <div class="category-container" *ngFor="let categoryItem of department?.children">
                <h3 class="titlte-category">
                  <a (click)="setChangeColor(department, categoryItem.name)" [ngStyle]="{color: department?.primaryColor}"
                    [id]="'department-menu-category-' + categoryItem.id"
                    routerLink="/categorias/{{ department?.nameUrl }}/{{ categoryItem.nameUrl }}">
                    {{ categoryItem.name }}
                  </a>
                </h3>
                <p class="cont-sub-category" *ngFor="let subCategory of categoryItem.children">
                  <a (click)="setChangeColor(department, category)" class="text-sub-category"
                    [id]="'department-menu-sub-category-' + subCategory.id" routerLink="/categorias/{{ department?.nameUrl }}/{{ categoryItem.nameUrl }}/{{
                      subCategory.nameUrl
                    }}">
                    {{ subCategory.name }}
                  </a>
                </p>
              </div>
            </div>
            <div *ngIf="activeDepartment[department?.name]" class="img-galery">
              <div class="content-img-galery">
                <div *ngFor="let url of imagesUrl[department?.name]; let i = index">
                  <a [id]="'department-menu-department-' + department?.id + '-banner-' + i"
                    [routerLink]="url.redirectUrl">
                    <img [attr.data-src]="url.imageUrl" alt="banner-category-{{ url.idDepartment }}"
                      class="img-simple lozad v-none" />
                  </a>
                </div>
              </div>
            </div>
            <div class="cont-load" *ngIf="!department?.children">
              <img class="img" src="assets/svg/icon-spinner.svg" alt="icono de cargando - Farmatodo" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isOtherCategory()" class="col-3">
      <div class="row other-category">
        <div *ngIf="configModule?.coupons" class="col-6 pr-0 d-flex align-items-center justify-content-center"
          (mouseover)="hide = false">
          <a id="department-menu-open-modal" (click)="setEmiterCoupon()">
            <img src="./assets/svg/coupon.svg" class="mr-2 img-fluid" alt="cupon farmatodo" />
            Ingresar cupón
          </a>
        </div>
        <div *ngIf="!disableSas && configModule?.programAndSave && false"
          class="col-6 d-flex align-items-center justify-content-center" (mouseover)="hide = false">
          <a id="department-menu-program-and-save-redirect" routerLink="/programate-y-ahorra/galeria">
            <img src="./assets/svg/subscribe-and-save-logo.svg" class="img-fluid subscribe"
              alt="Prográmate y ahorra farmatodo" />
          </a>
        </div>
        <app-prime-flag></app-prime-flag>
      </div>
    </div>
  </div>
</div>